<template>
  <CustomModal
    v-model:visible="visible"
    width="390px"
    :visible-sections="{
      header: false,
      body: true,
      footer: false,
    }"
    :section-classes="{
      container: 'rounded-2xl',
      body: '!p-0',
    }"
  >
    <template #default>
      <div
        class="px-6 py-8 flex roun flex-col gap-8 items-center justify-center"
      >
        <div>
          <ThemeImage
            class="size-[118px]"
            :icon="imageNames.SUPER_SALES_APP_LOGO"
            alt="super_sales_app_logo"
          />
        </div>
        <div class="flex flex-col gap-3">
          <span class="text_color text-center font-medium text-lg"
            >Manage all your sales on the go with</span
          ><span
            class="text_color text-center text-3xl font-semibold leading-[38px]"
            >SuperAGI Mobile App
          </span>
        </div>
        <div
          class="py-2 flex flex-col w-full items-center justify-center gap-2"
        >
          <a-button
            @click="handleGoToApp"
            class="max-w-[200px] w-[90%] primary_large rounded-xl"
            >Go to App</a-button
          >
          <span
            @click="visible = false"
            class="secondary_color text-sm font-normal leading-[17px]"
            >Continue on web</span
          >
        </div>
      </div>
    </template>
  </CustomModal>
</template>

<script setup>
import CustomModal from "@/src/components/CustomModal.vue";
import { computed, onMounted, ref, watch } from "vue";
import Bowser from "bowser";
import { mobileAppInfo } from "@/src/constants/appConstants.js";
import { message } from "ant-design-vue";
import { imageNames } from "@/src/constants/imageConstants.js";

const visible = ref(false);
const browserInfo = ref(null);

try {
  browserInfo.value = Bowser.getParser(window.navigator.userAgent);
} catch (error) {
  console.error("Error initializing Bowser:", error);
}

const viewedMobilePopup = computed(() => {
  try {
    const viewed = sessionStorage.getItem("viewedMobilePopup");
    return viewed === "true";
  } catch (error) {
    console.error("Error accessing session storage:", error);
    return false;
  }
});

const isMobileDevice = computed(() => {
  try {
    const os = browserInfo.value?.getOSName(true);
    return os === "ios" || os === "android";
  } catch (error) {
    console.error("Error detecting device type:", error);
    return false;
  }
});

const handleGoToApp = () => {
  try {
    const currentUrl = window.location.href;
    const urlObj = new URL(currentUrl);
    const path = urlObj.pathname;
    const queryParams = urlObj.search;

    const os = browserInfo.value?.getOSName(true);
    const browserName = browserInfo.value?.getBrowserName()?.toLowerCase();

    if (os === "ios" && browserName === "safari") {
      window.location.href = mobileAppInfo.storeLinks.ios;
    } else if (os === "android") {
      const androidAppUrl =
        mobileAppInfo.androidLink.replace("https://", "") + path + queryParams;

      window.location.href =
        `intent://${androidAppUrl}#Intent;` +
        `scheme=https;` +
        `package=${mobileAppInfo.androidPackage};` +
        `S.browser_fallback_url=${encodeURIComponent(mobileAppInfo.storeLinks.android)};` +
        "end;";
    } else if (os === "ios") {
      const appPath = path.replace(/^\//, "");

      const iosAppUrl = mobileAppInfo.iosLink + appPath + queryParams;

      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = iosAppUrl;

      document.body.appendChild(iframe);

      setTimeout(function () {
        document.body.removeChild(iframe);

        if (!document.hidden) {
          window.location.href = mobileAppInfo.storeLinks.ios;
        }
      }, 1500);
    }

    visible.value = false;
  } catch (error) {
    message.error("Something went wrong while opening the app");
    console.log("Error opening mobile app:", error);
  }
};

watch(visible, (newVal) => {
  if (!newVal) {
    sessionStorage.setItem("viewedMobilePopup", true);
  }
});

onMounted(() => {
  if (!viewedMobilePopup.value && isMobileDevice.value) {
    visible.value = true;
  }
});
</script>
